import type { ListBuilderList } from '../../../types';
import { createMerchandiserColumns } from '../columns';
import { MERCHANDISER_REQUIRED_FIELDS } from '../shared';

/**
 * Maintenance Merchandisers list configuration
 * Shows merchandiser locations under maintenance
 */
export const maintenanceMerchandisersList: ListBuilderList = {
	id: 'maintenance-merchandisers',
	cacheTTL: 600000,
	name: 'Maintenance Merchandisers',
	type: 'default',
	active: true,
	columns: createMerchandiserColumns(),
	description: 'Merchandiser locations under maintenance',
	defaultSortId: 'column-location-code-asc',
	filterRules: {
		locationType: {
			defaultValue: [{ id: 'merchandiser', label: 'Merchandiser' }],
		},
		locationStatus: {
			defaultValue: [{ id: 'maintenance', label: 'Maintenance' }],
		},
	},
	requiredFields: MERCHANDISER_REQUIRED_FIELDS,
	sortOrder: 2,
};
